import constantMessage from "@/helpers/constantMessage";
import Vue from "vue";

const state = {
  withTransition: {
    enterActive: "animated slideInRight",
    leaveActive: "animated slideOutLeft"
  },
  isMobile: false,
  theme: "",
  systemName: "Miraj Cinemas",
  systemLogo: require("@/assets/logos/miraj-logo.svg"),
  systemSmallLogo: require("@/assets/logos/miraj-logo.svg"),
  systemLogoDark: require("@/assets/logos/miraj-logo.svg"),
  copyright: "2020 mirajcinemas",
  footerLinks: [
    { link: "link", name: "Pro" },
    { link: "link", icon: "www.webapp.com" }
  ],
  routerName: null
};

const mutations = {
  SETDEVICE(state, isMobile) {
    state.isMobile = isMobile;
  },
  ON_SET_ROUTER_NAME: (state, payload) => {
    state.routerName = payload;
  }
};

const actions = {
  showErrorNotification: async ({ dispatch, commit, state }, payload) => {
    Vue.$notify(payload["message"] || constantMessage.AdminError, "error", {
      visibility: payload["time"] || 3000
    });
  },
  showSuccessNotification: async ({ dispatch, commit, state }, payload) => {
    Vue.$notify(payload["message"] || constantMessage.AdminError, "success", {
      visibility: payload["time"] || 3000
    });
  },
  showDevErrorNotification: async ({ dispatch, commit, state }, payload) => {
    console.log("payload", payload);
    process.env.NODE_ENV === "development"
      ? Vue.$notify(payload["message"] || constantMessage.AdminError, "error", {
          visibility: payload["time"] || 3000
        })
      : undefined;
  },
  showDevSuccessNotification: async ({ dispatch, commit, state }, payload) => {
    process.env.NODE_ENV === "development"
      ? Vue.$notify(
          payload["message"] || constantMessage.AdminError,
          "success",
          { visibility: payload["time"] || 3000 }
        )
      : undefined;
  },
  setRouterName: async ({ dispatch, commit, state }, payload) => {
    commit("ON_SET_ROUTER_NAME", payload);
  }
};

const getters = {
  getWithTransition: state => state.withTransition,
  getRouterName: state => state.routerName
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/AppSetting.js